import { render } from "./ImpedimentosView.vue?vue&type=template&id=459005ca&scoped=true"
import script from "./ImpedimentosView.vue?vue&type=script&lang=ts"
export * from "./ImpedimentosView.vue?vue&type=script&lang=ts"

import "./ImpedimentosView.vue?vue&type=style&index=0&id=459005ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-459005ca"

export default script